import { useEffect } from 'react'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Button } from '@/components/ui/button'

export const TICKET_PAGE_SIZE = 25

export function Pager({ page, total, onPage }: { page: number; total: number; onPage: (page: number) => void }) {
  const lastPage = Math.max(1, Math.ceil(total / TICKET_PAGE_SIZE))
  // The lists refresh while open, so a shrinking total can leave the page past the end: move back to the last one.
  useEffect(() => {
    if (page > lastPage) onPage(lastPage)
  }, [page, lastPage, onPage])

  if (total <= TICKET_PAGE_SIZE) return null
  const firstRow = (page - 1) * TICKET_PAGE_SIZE + 1
  const lastRow = Math.min(page * TICKET_PAGE_SIZE, total)
  return (
    <div className="mt-3 flex items-center justify-end gap-2 text-etn-micro text-etn-text-soft">
      <span className="tabular-nums">{firstRow === lastRow ? lastRow : `${firstRow}-${lastRow}`} of {total}</span>
      <Button size="sm" variant="outline" aria-label="Previous page" disabled={page <= 1} onClick={() => onPage(page - 1)}>
        <ChevronLeft className="h-3.5 w-3.5" />
      </Button>
      <Button size="sm" variant="outline" aria-label="Next page" disabled={lastRow >= total} onClick={() => onPage(page + 1)}>
        <ChevronRight className="h-3.5 w-3.5" />
      </Button>
    </div>
  )
}
